import PasswordValidator from 'password-validator';

export const AUTHORIZED_DOMAINS = ['alphonso.tv', 'lgads.tv'];
export const UMS_ACCOUNT_NAME = 'tv-lab';

export const COMMON_PASSWORDS = [
  'Passw0rd',
  'Password123',
  'password',
  'password123',
  '123abc',
  'asdfasdf',
  'asdf',
];

export const passwordSchema = new PasswordValidator()
  .is()
  .min(8)
  .is()
  .max(100)
  .has()
  .uppercase()
  .has()
  .lowercase()
  .has()
  .not()
  .spaces()
  .is()
  .not()
  .oneOf(COMMON_PASSWORDS);
